import {Injectable, Inject, PLATFORM_ID} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable()
export class ProgressBarService {

    color = '#9aae51';
    mode = 'determinate';
    value = 0;
    bufferValue = 100;

    constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

    hideProgressBar() {
        // Only access DOM in browser environment
        if (isPlatformBrowser(this.platformId)) {
            const appBar = document.getElementById('app-bar');
            if (appBar) {
                appBar.style.display = 'none';
            }
        }
    }

    start() {
        // Only access DOM in browser environment
        if (isPlatformBrowser(this.platformId)) {
            const appBar = document.getElementById('app-bar');
            if (appBar) {
                appBar.style.display = 'block';
            }
        }
        this.value = 0;
        this.incrementValue();
    }

    incrementValue() {
        const  context = this;
        setTimeout(function () {
            context.value += 30;
        }, 1000);
    }

    done () {
        this.value = 100;
        this.hideProgressBar();
    }

    stopAndHide() {
        this.value = 0;
        this.hideProgressBar();
    }
}
